import { render, staticRenderFns } from "./FetchErrorTransition.vue?vue&type=template&id=c053641c&lang=pug&"
import script from "./FetchErrorTransition.vue?vue&type=script&lang=js&"
export * from "./FetchErrorTransition.vue?vue&type=script&lang=js&"
import style0 from "./FetchErrorTransition.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports